class FeatureFlagService {
  private flagsGetter: (() => Record<string, boolean>) | null = null

  setFlagsGetter(getter: () => Record<string, boolean>): void {
    this.flagsGetter = getter
  }

  isEnabled(flagName: string): boolean {
    return (this.flagsGetter?.() ?? {})[flagName] ?? false
  }

  getAllFlags(): Record<string, boolean> {
    return this.flagsGetter?.() ?? {}
  }
}

export const featureFlagService = new FeatureFlagService()
